import {Skeleton} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function ProductCardSkeleton({page}: {page?: "index" | "product"}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    let imageSize = isMobile ? 130 : 170;


    return (
        <Box
            position="relative"
            minWidth={page === "product" ? "100%" : {xs: 200, md: "100%"}}
        >
            <Skeleton height={imageSize} variant="rectangular"/>

            <Box
                display="flex"
                flexDirection="column"
                textAlign="center"
                height={80}
            >
                <Typography variant="h6">
                    <Skeleton variant="text" width='100%' />
                </Typography>

                <Skeleton variant="text" width='100%' />

                <Box
                    display="flex"
                    justifyContent="end"
                    alignItems="flex-end"
                    height= '100%'
                >
                    <Skeleton  width={42} height={42} variant="rectangular" />
                </Box>
            </Box>
        </Box>
    );
}